$(document).ready(function()
{
    if (jQuery('.sortable-table').length){
        jQuery('.sortable-table').DataTable({
            "searching": false,
            "info": false,
            "paging": false
        });
    }

    if ($('.sortable-table-none').length)
    {
        $('.sortable-table-none').DataTable(
        {
            "searching": false,
            "info": false,
            "paging": false,
            "order": [[ 3, "desc" ]]
        });
    

    } 

});

//$.fn.dataTableExt.sErrMode = 'throw';